import { render, staticRenderFns } from "./vendorsComponent.vue?vue&type=template&id=3ed10342&"
import script from "./vendorsComponent.vue?vue&type=script&lang=js&"
export * from "./vendorsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports